import {
  IncomingProductCheckoutSessionUpdateDto,
  OutgoingProductCheckoutSessionDto
} from 'api/dtos/products/checkout';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function startCheckoutSession(
  organizationId: string
): Promise<OutgoingProductCheckoutSessionDto> {
  const { data } = await bounceApiClient.post(
    `/api/organizations/${organizationId}/memberships/checkout`
  );
  return data;
}

export async function updateCheckoutSession({
  organizationId,
  paymentIntentId,
  data
}: {
  organizationId: string;
  paymentIntentId: string;
  data: IncomingProductCheckoutSessionUpdateDto;
}): Promise<OutgoingProductCheckoutSessionDto> {
  const { data: response } = await bounceApiClient.put(
    `/api/organizations/${organizationId}/memberships/checkout/${paymentIntentId}`,
    data
  );
  return response;
}

export async function confirmCheckoutSession({
  organizationId,
  paymentIntentId
}: {
  organizationId: string;
  paymentIntentId: string;
}): Promise<{ redirectUrl?: string }> {
  const { data } = await bounceApiClient.post(
    `/api/organizations/${organizationId}/memberships/checkout/${paymentIntentId}/confirm`
  );
  return data;
}
